var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blank-wrap center-v-h"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title || '暂无相关内容'))])])}
var staticRenderFns = []

export { render, staticRenderFns }